import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AppCountryConfig } from './app-country-config.interface';

@Injectable()
export class AppConfigService {
    constructor(
    ) { }

    /**
    * @description this method will get the config settings for combo packs page
    * @date 2019-09-16
    * @memberof ProductDetailConfigSettings
    */
    public getSettings(countryCode: string): AppCountryConfig {
        let appCountryConfig: AppCountryConfig;
        switch (countryCode.toUpperCase()) {
            case 'USA':
                appCountryConfig = this.loadUSASettings();
                break;
            case 'CAN':
                appCountryConfig = this.loadCANSettings();
                break;
            case 'GBR':
                appCountryConfig = this.loadGBRSettings();
                break;
            default:
                appCountryConfig = this.loadUSASettings();
                break;
        }
        return appCountryConfig;
    }

    /**
     * @description this method will return usa settings
     * @date 2019-09-19
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadUSASettings(): AppCountryConfig {
        const appConfigSetting: AppCountryConfig = {
            countryCode: 'USA',
            fpc5PercentEnabled: true,
            restrictOrder: false
        };
        return appConfigSetting;
    }

    /**
     * @description this method will return CAN settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadCANSettings(): AppCountryConfig {
        const appConfigSetting: AppCountryConfig = {
            countryCode: 'CAN',
            fpc5PercentEnabled: true,
            restrictOrder: false
        };
        return appConfigSetting;
    }

    /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadGBRSettings(): AppCountryConfig {
        const appConfigSetting: AppCountryConfig = {
                countryCode: 'GBR',
                fpc5PercentEnabled: true,
                restrictOrder: true
        };
        return appConfigSetting;

    }

    /**
       * To handle the obervable error response
       * @param  {Response|any} error
       */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error.message || error);
    }
}
